// import Vue from 'vue'
import moment from 'moment'

export const state = {
  dateRange: { startDate: moment().add(-2, 'd'), endDate: moment() },
}

export const mutations = {
  SET_SELECTED_DATE_RANGE(state, payload) {
    state.dateRange = payload
  },
}

export const getters = {
  getSelectedDateRange(state) {
    return state.dateRange
  },
}

export const actions = {
  SET_SELECTED_DATE_RANGE({ commit, dispatch, getters }, payload) {
    commit('SET_SELECTED_DATE_RANGE', payload)
  },
}
